import clsx from 'clsx';
import { vars } from 'src/core/themes';
import { useMatchMedia } from 'src/hooks/useMatchMedia';
import { useUserHasFeature } from 'src/hooks/useUserHasFeature';
import { EventWithData, Feature } from 'src/WebApiController';

import { DashboardSection } from '../DashboardSection';
import * as styles from '../InventoryEventPage.css';
import { DashboardSectionMobile } from '../InventoryEventPageRework/Mobile/Dashboard/DashboardSectionMobile';

type InventoryEventContentProps = {
  accordionItemProps?: EventWithData;
  isOnSaleEvent?: boolean;
};

export function InventoryEventDashboardSection({
  accordionItemProps,
  isOnSaleEvent,
}: InventoryEventContentProps) {
  const hasMobileInventoryPageFeature = useUserHasFeature(
    Feature.MobileInventoryEventPage
  );
  const isMobileLayout =
    useMatchMedia('mobile') && hasMobileInventoryPageFeature;
  return (
    <div className={clsx(styles.tableSection)}>
      {accordionItemProps && (
        <div
          className={clsx(
            styles.tableContainer,
            styles.inventoryEventPageTableContainer
          )}
          style={{ gap: vars.spacing['lg'] }}
        >
          {isMobileLayout ? (
            <DashboardSectionMobile
              event={accordionItemProps}
              isOnSaleEvent={isOnSaleEvent}
            />
          ) : (
            <DashboardSection
              event={accordionItemProps}
              isOnSaleEvent={isOnSaleEvent}
            />
          )}
        </div>
      )}
    </div>
  );
}
